var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"final-tirp-down"},[_c('p',{staticClass:"countDown"},[_vm._v("Only "+_vm._s(_vm.classesRemaining)+" classes left! "+_vm._s(_vm.countDown)+" remaining!")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a35d1af","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinalTIRPDown.vue
// module id = null
// module chunks = 